export const openLink = (url: string) => {
  const win = window.open(url, '_self')
  if (win != null) {
    win.focus()
  }
}
